import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden watermark-bg" data-id="element-163">
      <div className="max-w-3xl mx-auto text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <span className="inline-block py-1 px-3 rounded-full bg-gold/10 text-gold font-semibold text-xs tracking-widest uppercase mb-6" data-id="element-166">
            The 5-Minute Discernment Framework
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-charcoal" data-id="element-167">
            You've Prayed About It. <br className="hidden md:block" data-id="element-168" />
            You've Journaled About It. <br className="hidden md:block" data-id="element-169" />
            You've Asked Everyone You Trust.
          </h1>

          <p className="text-xl md:text-2xl font-serif italic text-charcoal/80 mb-8" data-id="element-170">
            So Why Does the Decision Still Feel This Loud?
          </p>

          <p className="text-lg md:text-xl font-medium text-charcoal mb-12" data-id="element-171">
            It's not a faith problem. It's a framework problem.
          </p>
        </motion.div>

        {/* Book Mockup Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full max-w-lg mx-auto mb-12" data-id="element-172">
          <img src="https://cdn.magicpatterns.com/uploads/m5WeuXNp83X3tA3KPbBuXg/Is_This_God_or_My_Fear_-_Landing_Page_-_Imagen_01.png" alt="Is This God or My Fear? — Relationship Edition: Peace vs. Attachment — Book and tablet mockup" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-173" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-174">
          <blockquote className="text-lg md:text-xl font-serif italic text-charcoal/90 mb-10 border-l-2 border-gold pl-6 text-left max-w-2xl mx-auto" data-id="element-175">
            "Turn a loud relationship decision into a clear next step in 5
            minutes using Body + Fruit + Timing."
          </blockquote>

          <CTAButton mainText="GET INSTANT ACCESS — $17.95" subText="Yes, I want clarity on my loudest relationship decision — starting tonight. Instant download. No waiting. Use it in 5 minutes." large data-id="element-176" />
        </motion.div>
      </div>
    </section>;
}